import sessions from './sessions';
import noSessions from './no-sessions';
import location from './location';

export default (config) => ({
  sessions: sessions(config),
  noSessions: noSessions(config),
  location: location(config),
  monthExpanded: (state) => (name) => {
    const { toggledMonths } = state;
    return toggledMonths.includes(name);
  },
  monthSessionsExpanded: (state) => (name) => {
    const { toggledMonthSessions } = state;
    return toggledMonthSessions.includes(name);
  },
  monthSoldOutSessionsExpanded: (state) => (name) => {
    const { toggledSoldOutSessions } = state;
    return toggledSoldOutSessions.includes(name);
  },
});
